import SwitchBase from './SwitchBase';

export default SwitchBase;



// WEBPACK FOOTER //
// ./src/switchBase/index.js